module.exports = __webpack_public_path__ + "img/img-main-bg-09.1d2127f4.svg";